const getAlbumGenresAsString = ( album ) => {
  let string = ''
  console.log(album.genre)
  album.genre.forEach((genre) => {
    string += `${genre.name}, `
  })
  return string.trim().replace(/,$/, '')
  
}
export default getAlbumGenresAsString